module.exports = __webpack_public_path__ + "img/sitelogo.781c6350.png";